import { MAIN_COLOR, SHADOW_COLOR } from 'shared/consts/styleValues';
import styled from 'styled-components';
import { PreloaderProps } from './types';

export const Preloader = styled.div<PreloaderProps>`
	border: 4px solid ${props => props.$borderColor || SHADOW_COLOR};
	border-top: 4px ${props => props.$borderTopColor || MAIN_COLOR} solid;
	border-radius: 50%;
	height: ${props => props.$height || '24px'};
	width: ${props => props.$width || '24px'};
	animation: spin 2s linear infinite;

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}

		100% {
			transform: rotate(360deg);
		}
	}
`;

export const PreloaderContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: 100%;
`;
